import {
  CourseOptionSelectItemContainer,
  CourseOptionSelect,
  CourseOptionSelectItem,
} from '@app/evaluation-settings-menu/HeaderArea.styles'
import { getActiveAdjustment, getAdjustmentValue } from '@app/evaluation-core'

import React from 'react'
import useAdjustment from '@common/hooks/useAdjustment'
import useEvaluation from '@common/hooks/useEvaluation'
import useEvaluationUser from '@common/hooks/useEvaluationUser'
import useSetAdjustment from '@common/hooks/useSetAdjustment'

interface TweenerProps {
  useLz?: boolean
}

export const Tweener = ({ useLz }: TweenerProps) => {
  const adjustments = useAdjustment()
  const [setAdjustment] = useSetAdjustment()

  const { currentId } = useEvaluation()
  const { view } = useEvaluationUser()

  const currentAdjustment = getActiveAdjustment()
  const adjustmentFormat =
    currentAdjustment?.shots || currentAdjustment?.landingZones
      ? 'shot'
      : 'golfer'

  const value = getAdjustmentValue(
    adjustmentFormat,
    view,
    `${currentAdjustment?.valueKey}_tweener`,
    adjustments
  )

  const optionalAdjustments = [-1, 1]


  return (
    <div
      style={{
        width: '160px',
      }}
    >
      <CourseOptionSelect>
        {optionalAdjustments.map((val) => (
          <CourseOptionSelectItemContainer
            key={`tweener-${val}`}
            style={{
              flexBasis:
                val === -1 && optionalAdjustments.length > 2 ? '100%' : '',
              padding:
                val === -1 && optionalAdjustments.length > 2 ? '0px 6px' : 0,
            }}
          >
            <CourseOptionSelectItem
              selected={value === val}
              onPress={() =>
                setAdjustment(
                  adjustmentFormat,
                  view,
                  `${currentAdjustment?.valueKey}_tweener`,
                  currentId as string,
                  value === val ? 0 : val
                )
              }
            >
              {val > 0 && `+`}
              {val}
            </CourseOptionSelectItem>
          </CourseOptionSelectItemContainer>
        ))}
      </CourseOptionSelect>
    </div>
  )
}
